import { createSlice } from "@reduxjs/toolkit";

const savedLanguage = JSON.parse(localStorage.getItem("selectedLanguage"));

const initialState = {
  languages: [
    { title: "Türkçe", value: "tr" },
    { title: "English", value: "en" },
  ],
  language: savedLanguage || { title: "English", value: "en" },
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      localStorage.setItem("selectedLanguage", JSON.stringify(action.payload));
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
